import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  @import url('https://use.typekit.net/[your-kit-code].css'); // You'll need to get the actual Adobe fonts

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: ${props => props.theme.fonts.primary};
    color: ${props => props.theme.colors.text.primary};
    line-height: 1.6;
    background-color: ${props => props.theme.colors.background.light};
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${props => props.theme.fonts.secondary};
    font-weight: bold;
  }

  .accent-text {
    font-family: ${props => props.theme.fonts.accent};
  }

  /* Add more global styles as needed */

  /* Spin animation for loading spinners */
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .spin {
    animation: spin 1s linear infinite;
  }
`; 